import {BaseOptions} from "../../../../dialog/options/base.options";

export class FactorDetailOptions extends BaseOptions {
  factorId?: any;
  onFactorSelected = (factor: any) => {
  };
}
